export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    ASK_FOR_OFFER: "ask-for-offer-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    DETAILS_COMPARE_BUTTON_MOBILE: "details-compare-button-mobile",
    DETAILS_ASK_FOR_OFFER_DESKTOP: "details-ask-for-offer-button-desktop",
    OFFER_GALLERY: "offer-gallery",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "thumb-up",
    DISLIKE_BUTTON: "thumb-down",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    EXPANDABLE_SECTION: "expandable-section-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    RESTORE_BUTTON: "restore-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    DISMISS_BUTTON: "dismiss-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal",
    THUMB_UP: "thumb-up",
    THUMB_DOWN: "thumb-down",
    PROPERTY_BOX: "property-box",
    PROPERTY_BOX_PRICE: "property-box-price",
    DETAIL_VIEW: "property-detail-view",
    DETAIL_BACK_LINK: "property-detail-back-link",
    DETAIL_MOBILE_CTA_PANEL: "property-detail-mobile-cta-panel",
    DETAIL_PAGE_HEADER: "property-detail-page-header",
    DETAIL_SECTION_NAV: "property-detail-section-nav",
    DETAIL_THREAD_SIDEBAR: "property-detail-thread-sidebar",
    PHONE_MODAL: "property-phone-modal",
    PHONE_REVEALED: "property-phone-revealed",
    GALLERY_MODAL: "property-gallery-modal",
    GALLERY_GRID: "property-gallery-grid",
    GALLERY_VIEWER: "property-gallery-viewer",
    GALLERY_COUNTER: "property-gallery-counter",
    GALLERY_VIEWER_CLOSE: "property-gallery-viewer-close",
    GALLERY_THUMBNAIL_PREFIX: "property-gallery-thumbnail",
    GALLERY_ARROW_LEFT: "property-gallery-arrow-left",
    GALLERY_ARROW_RIGHT: "property-gallery-arrow-right",
    GALLERY_VIEWER_SLIDE: "property-gallery-viewer-slide",
    GALLERY_DOTS: "property-gallery-dots",
    GALLERY_DOT: "property-gallery-dot",
    GALLERY_DOT_ACTIVE: "property-gallery-dot-active",
    GALLERY_SWIPE_ONBOARDING: "property-gallery-swipe-onboarding",
    NEIGHBORHOOD_DETECTIVE: "km-neighborhood-detective",
    NEIGHBORHOOD_DETECTIVE_HEADER: "km-neighborhood-detective-header",
    NEIGHBORHOOD_DETECTIVE_LOADING: "km-neighborhood-detective-loading",
    NEIGHBORHOOD_DETECTIVE_RESULT: "km-neighborhood-detective-result",
    NEIGHBORHOOD_DETECTIVE_PROS: "km-neighborhood-detective-pros",
    NEIGHBORHOOD_DETECTIVE_CONS: "km-neighborhood-detective-cons",
    NEIGHBORHOOD_DETECTIVE_ERROR: "km-neighborhood-detective-error",
    NEIGHBORHOOD_DETECTIVE_RETRY: "km-neighborhood-detective-retry",
    NEIGHBORHOOD_DETECTIVE_UNAVAILABLE: "km-neighborhood-detective-unavailable",
    DETAILS_PARAMETERS_FILL_IN_BUTTON: "km-details-parameters-fill-in-button",
    DETAILS_PARAMETERS_SAVE_BUTTON: "km-details-parameters-save-button",
    DETAILS_PARAMETERS_CANCEL_BUTTON: "km-details-parameters-cancel-button",
    DETAILS_DESCRIPTION_ADD_BUTTON: "km-details-description-add-button",
    DETAILS_DESCRIPTION_EDIT_BUTTON: "km-details-description-edit-button",
    DETAILS_DESCRIPTION_SAVE_BUTTON: "km-details-description-save-button",
    DETAILS_HEADER_LOCATION_INPUT: "km-details-header-location-input",
    DETAILS_HEADER_PRICE_INPUT: "km-details-header-price-input",
    DETAILS_LOCATION_ADD_BUTTON: "km-details-location-add-button",
    DETAILS_LOCATION_EDIT_BUTTON: "km-details-location-edit-button",
    DETAILS_LOCATION_MODAL: "km-details-location-modal",
    DETAILS_LOCATION_SAVE_BUTTON: "km-details-location-save-button"
} as const;
export const KM_OFFER_TEST_IDS = {
    OFFER_WRAPPER: "offer-wrapper",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    ASK_FOR_OFFER: "ask-for-offer-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    OFFER_DETAILS: "offer-details-button",
    DETAILS_ASK_FOR_OFFER: "details-ask-for-offer-button",
    DETAILS_ASK_FOR_OFFER_MOBILE: "details-ask-for-offer-button-mobile",
    DETAILS_COMPARE_BUTTON_MOBILE: "details-compare-button-mobile",
    DETAILS_ASK_FOR_OFFER_DESKTOP: "details-ask-for-offer-button-desktop",
    OFFER_GALLERY: "offer-gallery",
    SHOW_PHONE_NUM: "show-phone-num-button",
    LIKE_BUTTON: "thumb-up",
    DISLIKE_BUTTON: "thumb-down",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    EXPANDABLE_SECTION: "expandable-section-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    RESTORE_BUTTON: "restore-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    DISMISS_BUTTON: "dismiss-button",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    CONFIRM_SEND_LEAD: "confirm-send-lead-button",
    AFTER_LIKE_MODAL: "after-like-modal",
    AFTER_DISLIKE_MODAL: "after-dislike-modal",
    THUMB_UP: "thumb-up",
    THUMB_DOWN: "thumb-down",
    PROPERTY_BOX: "property-box",
    PROPERTY_BOX_PRICE: "property-box-price",
    DETAIL_VIEW: "property-detail-view",
    DETAIL_BACK_LINK: "property-detail-back-link",
    DETAIL_MOBILE_CTA_PANEL: "property-detail-mobile-cta-panel",
    DETAIL_PAGE_HEADER: "property-detail-page-header",
    DETAIL_SECTION_NAV: "property-detail-section-nav",
    DETAIL_THREAD_SIDEBAR: "property-detail-thread-sidebar",
    PHONE_MODAL: "property-phone-modal",
    PHONE_REVEALED: "property-phone-revealed",
    GALLERY_MODAL: "property-gallery-modal",
    GALLERY_GRID: "property-gallery-grid",
    GALLERY_VIEWER: "property-gallery-viewer",
    GALLERY_COUNTER: "property-gallery-counter",
    GALLERY_VIEWER_CLOSE: "property-gallery-viewer-close",
    GALLERY_THUMBNAIL_PREFIX: "property-gallery-thumbnail",
    GALLERY_ARROW_LEFT: "property-gallery-arrow-left",
    GALLERY_ARROW_RIGHT: "property-gallery-arrow-right",
    GALLERY_VIEWER_SLIDE: "property-gallery-viewer-slide",
    GALLERY_DOTS: "property-gallery-dots",
    GALLERY_DOT: "property-gallery-dot",
    GALLERY_DOT_ACTIVE: "property-gallery-dot-active",
    GALLERY_SWIPE_ONBOARDING: "property-gallery-swipe-onboarding",
    NEIGHBORHOOD_DETECTIVE: "km-neighborhood-detective",
    NEIGHBORHOOD_DETECTIVE_HEADER: "km-neighborhood-detective-header",
    NEIGHBORHOOD_DETECTIVE_LOADING: "km-neighborhood-detective-loading",
    NEIGHBORHOOD_DETECTIVE_RESULT: "km-neighborhood-detective-result",
    NEIGHBORHOOD_DETECTIVE_PROS: "km-neighborhood-detective-pros",
    NEIGHBORHOOD_DETECTIVE_CONS: "km-neighborhood-detective-cons",
    NEIGHBORHOOD_DETECTIVE_ERROR: "km-neighborhood-detective-error",
    NEIGHBORHOOD_DETECTIVE_RETRY: "km-neighborhood-detective-retry",
    NEIGHBORHOOD_DETECTIVE_UNAVAILABLE: "km-neighborhood-detective-unavailable",
    DETAILS_PARAMETERS_FILL_IN_BUTTON: "km-details-parameters-fill-in-button",
    DETAILS_PARAMETERS_SAVE_BUTTON: "km-details-parameters-save-button",
    DETAILS_PARAMETERS_CANCEL_BUTTON: "km-details-parameters-cancel-button",
    DETAILS_DESCRIPTION_ADD_BUTTON: "km-details-description-add-button",
    DETAILS_DESCRIPTION_EDIT_BUTTON: "km-details-description-edit-button",
    DETAILS_DESCRIPTION_SAVE_BUTTON: "km-details-description-save-button",
    DETAILS_HEADER_LOCATION_INPUT: "km-details-header-location-input",
    DETAILS_HEADER_PRICE_INPUT: "km-details-header-price-input",
    DETAILS_LOCATION_ADD_BUTTON: "km-details-location-add-button",
    DETAILS_LOCATION_EDIT_BUTTON: "km-details-location-edit-button",
    DETAILS_LOCATION_MODAL: "km-details-location-modal",
    DETAILS_LOCATION_SAVE_BUTTON: "km-details-location-save-button"
} as const;
